export default "__VITE_ASSET__Cl$e7rrn__"